import { render, staticRenderFns } from "./ConcessionariaProxima.vue?vue&type=template&id=5b720a5f&scoped=true"
import script from "./ConcessionariaProxima.vue?vue&type=script&lang=js"
export * from "./ConcessionariaProxima.vue?vue&type=script&lang=js"
import style0 from "./ConcessionariaProxima.vue?vue&type=style&index=0&id=5b720a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b720a5f",
  null
  
)

export default component.exports